<template>
  <div>
    <order-dialog ref="dialog" @submitted="fetchData" />
    <GmapMap
      :center="{ lat: 10, lng: 10 }"
      :zoom="zoom"
      style="width: 100%; height: calc(100vh - 65px - 70px)"
      ref="gmap"
      :options="{
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUI: false,
      }"
    >
      <GmapCluster ref="gmapCluster" :zoomOnClick="true" :maxZoom="16">
        <GmapMarker
          :key="index"
          v-for="(m, index) in filteredMarkers"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          :icon="
            m.available ? 'media/available.png' : 'media/not_available.png'
          "
          @click="toggleInfoWindow(m, index)"
        >
        </GmapMarker>
        <GmapInfoWindow
          :position="infoWindowPos"
          :opened="infoWinOpen"
          :options="{ maxWidth: 450 }"
          @closeclick="infoWinOpen = false"
        >
          <div v-if="currentMarker" class="vehicle-card">
            <div
              v-if="currentMarker.vehicle_type"
              class="vehicle-card__row row"
            >
              <span class="vehicle-card__col col-4">
                <strong>Техника</strong>
              </span>
              <span class="vehicle-card__col col-8">
                {{ currentMarker.vehicle_type.name }}
              </span>
            </div>
            <div class="vehicle-card__row row">
              <span class="vehicle-card__col col-4">
                <strong>Доступен</strong>
              </span>
              <span class="vehicle-card__col col-8">
                <span
                  v-if="currentMarker.available"
                  class="badge badge-success badge-inline"
                >
                  Свободен
                </span>
                <span v-else class="badge badge-danger badge-inline">
                  Занят
                </span>
              </span>
            </div>
            <div class="vehicle-card__row row">
              <span class="vehicle-card__col col-4">
                <strong>Телефон</strong>
              </span>
              <span class="vehicle-card__col col-8">
                <a
                  :href="`tel:${currentMarker.phone}`"
                  style="font-weight: bold"
                >
                  {{ currentMarker.phone }}
                </a>
              </span>
            </div>
            <div class="vehicle-card__row row">
              <span class="vehicle-card__col col-4">
                <strong>Имя техники</strong>
              </span>
              <span class="vehicle-card__col col-8">
                {{ currentMarker.name }}
              </span>
            </div>
            <div v-if="currentMarker.photo.url" class="vehicle-card__picture">
              <img
                :src="currentMarker.photo.url"
                class="vehicle-card__img"
                alt=""
              />
            </div>
            <div class="text-right">
              <v-btn
                color="primary"
                v-if="currentMarker.available"
                @click="newOrder(currentMarker)"
              >
                Заказать
              </v-btn>
            </div>
          </div>
        </GmapInfoWindow>
      </GmapCluster>

      <div slot="visible">
        <div style="left: 10px; top: 10px; position: absolute">
          <v-btn color="primary" dark @click.stop="drawer = !drawer" fab small>
            <v-icon small>fa fa-filter</v-icon>
          </v-btn>
        </div>

        <v-navigation-drawer v-model="drawer" bottom absolute temporary>
          <v-card>
            <v-card-title>Фильтр</v-card-title>
            <v-form style="padding: 8px">
              <v-select
                :items="categories"
                label="Категория"
                solo
                item-text="name"
                item-value="id"
                v-model="filter.category_id"
              ></v-select>
              <v-select
                :items="types"
                label="Тип"
                solo
                item-text="name"
                item-value="id"
                v-model="filter.type_id"
              ></v-select>

              <v-btn @click="resetFilter">Сброс</v-btn>
            </v-form>
            <v-card-title>Техника</v-card-title>
            <v-list nav dense>
              <v-list-item-group>
                <v-list-item
                  :key="index"
                  v-for="(marker, index) in filteredMarkers"
                >
                  <v-list-item-content @click="toggleInfoWindow(marker, index)">
                    <div class="row" v-if="marker.vehicle_type">
                      <span class="col-md-4"><strong>Техника</strong></span>
                      <span class="col-md-8">{{
                        marker.vehicle_type.name
                      }}</span>
                    </div>
                    <div class="row">
                      <span class="col-md-4"><strong>Доступен</strong></span>
                      <span class="col-md-8">
                        <span
                          class="badge badge-success badge-inline"
                          v-if="marker.available"
                          >Свободен</span
                        >
                        <span class="badge badge-danger badge-inline" v-else
                          >Занят</span
                        >
                      </span>
                    </div>
                    <div class="row">
                      <span class="col-md-4"><strong>Телефон</strong></span>
                      <span class="col-md-8"
                        ><a
                          :href="`tel:${marker.phone}`"
                          style="font-weight: bold"
                          >{{ marker.phone }}</a
                        ></span
                      >
                    </div>
                    <div class="row">
                      <span class="col-md-4"><strong>Имя техники</strong></span>
                      <span class="col-md-8">{{ marker.name }}</span>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-navigation-drawer>
      </div>
    </GmapMap>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { gmapApi } from "gmap-vue";
import OrderDialog from "@/view/pages/client/orders/OrderDialog.vue";

import moment from "moment";
moment.locale("ru");

export default {
  name: "map",
  metaInfo: {
    title: "Карта",
  },
  components: { OrderDialog },
  data() {
    return {
      loading: false,
      markers: [],
      filterCategories: [],
      zoom: 7,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      currentMarker: null,
      drawer: null,
      filter: {
        category_id: null,
        type_id: null,
      },
    };
  },
  computed: {
    google: gmapApi,
    filteredMarkers: function () {
      return this.markers.filter((marker) => {
        let visible = true;

        if (
          this.filter.category_id &&
          this.filter.category_id != marker.vehicle_category.id
        ) {
          visible = false;
        }

        if (
          this.filter.type_id &&
          this.filter.type_id != marker.vehicle_type.id
        ) {
          visible = false;
        }

        return visible;
      });
    },
    categories: function () {
      return Object.values(
        this.markers.reduce(function (result, marker) {
          if (!result[marker.vehicle_category.id]) {
            result[marker.vehicle_category.id] = {
              id: marker.vehicle_category.id,
              name: marker.vehicle_category.name,
            };
          }

          return result;
        }, {})
      );
    },
    types: function () {
      const categoryId = this.filter.category_id;

      if (!categoryId) return [];

      return Object.values(
        this.markers.reduce(function (result, marker) {
          if (
            !result[marker.vehicle_type.id] &&
            categoryId == marker.vehicle_category.id
          ) {
            result[marker.vehicle_type.id] = {
              id: marker.vehicle_type.id,
              name: marker.vehicle_type.name,
            };
          }

          return result;
        }, {})
      );
    },
  },
  async mounted() {
    await this.$gmapApiPromiseLazy();

    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Карта" }]);
    this.fetchData();
  },
  watch: {
    filter: {
      handler: function () {
        this.setBounds();
      },
      deep: true,
    },
  },
  methods: {
    resetFilter() {
      this.filter = {
        category_id: null,
        type_id: null,
      };
    },
    toggleInfoWindow(marker, index) {
      this.drawer = false;
      this.currentMarker = marker;
      this.infoWindowPos = marker.position;

      if (this.currentMidx == index) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = index;
      }
    },
    setBounds() {
      const map = this.$refs.gmap;
      const google = this.google;

      var bounds = new this.google.maps.LatLngBounds();
      this.filteredMarkers.forEach((marker) => {
        bounds.extend(
          new this.google.maps.LatLng(marker.position.lat, marker.position.lng)
        );
      });
      map.fitBounds(bounds);

      var listener = google.maps.event.addListener(
        map.$mapObject,
        "idle",
        function () {
          if (map.$mapObject.getZoom() > 17) map.$mapObject.setZoom(17);
          google.maps.event.removeListener(listener);
        }
      );

      this.$refs.gmapCluster.$clusterObject.repaint();
    },
    fetchData() {
      this.loading = true;
      this.$api["client/vehicles"]
        .select()
        .then((response) => {
          this.markers = response.data.items.filter(
            (marker) => !!marker.position
          );
        })
        .finally(() => {
          this.loading = false;
          this.setBounds();
        });
    },
    newOrder(marker) {
      this.toggleInfoWindow(this.currentMarker, this.currentMidx);

      this.$refs.dialog.open({
        vehicle_type_id: marker.vehicle_type.id,
        suborder: {
          vehicle_id: marker.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.vehicle-card {
  padding: 0 14px;

  &__row {
    margin-bottom: 8px;
  }

  &__col {
    padding-top: 0;
    padding-bottom: 0;
  }

  &__picture {
    position: relative;
    width: 300px;
    max-width: 100%;
    margin: 16px 0;

    &::after {
      content: "";
      display: block;
      padding-bottom: 70%;
    }
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
